import React from 'react';
import { FloatingMenu, Forms, StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';

export const PeriodPicker = ({ value, error, onChange, help, label, metric, limitTypes }) => {
    const showFormHelp = useSelector(state => state.ui.showFormHelp);

    const [periodType, setPeriodType] = React.useState('M');
    const [periodOffset, setPeriodOffset] = React.useState(null);

    const noWeek = ['LKIN', 'GONG'].some(a => a === metric);

    React.useEffect(() => {
        const safeValue = noWeek && value.charAt(0) === 'W' ? 'ALL' : value;
        if (safeValue === 'ALL') {
            setPeriodType('All');
            setPeriodOffset('1');
        } else {
            setPeriodType(safeValue.length > 0 ? safeValue.charAt(0) : 'M');
            if (safeValue.length > 1) {
                setPeriodOffset(safeValue.charAt(1));
            } else {
                setPeriodOffset('1');
            }
        }
    }, [value]);

    React.useEffect(() => {
        if (periodOffset && (!limitTypes || limitTypes.some(x => x === periodType))) {
            if (periodType === 'All') {
                onChange('ALL');
            } else {
                onChange(`${periodType}${periodOffset}`);
            }
        }
    }, [periodType, periodOffset]);

    const st = (path, ...rest) => SystemText(`General/Controls/PeriodPicker/${path}`, ...rest);

    const periodBtn = p => (
        <li className="flex flex-center" onClick={() => setPeriodType(p)}>
            {st(`Period/${p}`)}
        </li>
    );

    const dataOptions = React.useCallback(() => {
        const result = [];
        result.push({ id: '1', name: st(`Period/This`, st(`Period/${periodType}`)) });
        result.push({ id: '2', name: st(`Period/Last`, st(`Period/${periodType}`)) });
        result.push({ id: '3', name: st(`Period/Ago`, 2, st(`Period/${periodType}`)) });
        result.push({ id: '4', name: st(`Period/Ago`, 3, st(`Period/${periodType}`)) });
        return result;
    }, [periodType]);

    const allowed = type => {
        return !limitTypes || limitTypes.some(t => t === type);
    };

    return (
        <div className="metric-picker">
            <div className={`form-group ${error && 'has-error'}`}>
                <label className="mb5">
                    {label || st('Label')}
                    {<span className="mandatory">*</span>}
                </label>
                {showFormHelp && (help || st('Help')) && <span className="form-control-help">{help || st('Help')}</span>}
                <div className="flex mbm10">
                    <FloatingMenu buttonText={st(`Period/${periodType}`)}>
                        {allowed('All') && periodBtn('All')}
                        {allowed('W') && !noWeek && periodBtn('W')}
                        {allowed('M') && periodBtn('M')}
                        {allowed('Q') && periodBtn('Q')}
                        {allowed('Y') && periodBtn('Y')}
                    </FloatingMenu>
                    {periodType !== 'All' && (
                        <div className="flex-grow ml10 tight tight-1">
                            <div>
                                <Forms.Select
                                    label={null}
                                    mandatory
                                    data={dataOptions()}
                                    onChange={x => setPeriodOffset(x)}
                                    value={periodOffset}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {noWeek && (
                <div className="mtm10 text-sm flex flex-center">
                    <i className="mr5 fa fa-warning text-danger" />
                    <span>{st('Limitations')}</span>
                </div>
            )}
        </div>
    );
};

export default PeriodPicker;
